const formatNumber = num => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};
export default function animateCounter(el, endValue, duration = 2000) {
    let startTime = null;

    const step = timestamp => {
        if (!startTime) startTime = timestamp;

        const progress = Math.min((timestamp - startTime) / duration, 1);

        const currentValue = Math.floor(progress * endValue);
        el.textContent = formatNumber(currentValue);

        if (progress < 1) {
            requestAnimationFrame(step);
        } else {
            el.textContent = formatNumber(endValue);
        }
    };

    requestAnimationFrame(step);
}
